import { trackEvent } from "../analytics";
import { ANALYTICS } from "./analyticsEvents";

/**
 * @param {{ surface?: 'chat'|'schule', trigger?: string }} args
 */
export function trackSharePromptShown({ surface, trigger } = {}) {
  trackEvent(ANALYTICS.share_prompt_shown, {
    ...(surface ? { surface } : {}),
    ...(trigger ? { trigger } : {}),
  });
}

/**
 * @param {{ surface?: 'chat'|'schule' }} args
 */
export function trackSharePromptDismissed({ surface } = {}) {
  trackEvent(ANALYTICS.share_prompt_dismissed, {
    ...(surface ? { surface } : {}),
  });
}
